import { createModel } from '@rematch/core';
import { CartLineItem, CartLineItemsData } from 'domains/cartDomain';
import type { RootModel } from 'models';
import { BaseState, baseReducers } from 'models/baseReducers';
import cartService from 'services/cartService';

interface CartState extends BaseState {
  list: CartLineItemsData;
  total: number;
  cartLaterIds: number[];
  cartNowIds: number[];
  cartTotal: number;
  cartItem: CartLineItem | null;
}

export const cart = createModel<RootModel>()({
  state: {
    list: {},
    total: 0,
    cartLaterIds: [],
    cartNowIds: [],
    cartTotal: 0,
    cartItem: null,
  } as unknown as CartState,
  reducers: {
    ...baseReducers<CartState>(),
  },
  effects: (dispatch) => {
    const { cart } = dispatch;
    return {
      updateCartItem(cartItem: CartLineItem) {
        cart.setState({
          cartItem,
        });
      },

      clearCartItem() {
        cart.setState({
          cartItem: null,
        });
      },

      updateCartList(lineItemsData: CartLineItemsData) {
        cart.setState({
          list: lineItemsData,
          total:
            (lineItemsData.orderLaterJobs || []).length +
            (lineItemsData.orderNowJobs || []).length,
          cartLaterIds: lineItemsData.orderLaterJobs?.map((item) => item.jobId),
          cartNowIds: lineItemsData.orderNowJobs?.map((item) => item.jobId),
          cartTotal:
            lineItemsData.orderNowJobs
              ?.map((item) => item.costLineItems.totalCharge)
              .reduce((a, b) => a + b, 0) || 0,
        });
      },

      async getList(payload, state) {
        if (state.app.user?.userId) {
          // dispatch.app.showLoading();
          try {
            const lineItemsData = await cartService.getItems(
              state.app.user?.userId
            );
            // dispatch.app.hideLoading();
            cart.updateCartList(lineItemsData);
          } catch {
            // dispatch.app.hideLoading();
          }
        }
      },

      async moveToOrderLater(itemId: number, state): Promise<void> {
        if (state.app.user?.userId) {
          try {
            const lineItemsData = await cartService.moveToOrderLater(
              state.app.user?.userId,
              itemId
            );
            console.log(
              'lineItemsData',
              lineItemsData.orderNowJobs?.map((item) => item.jobId)
            );
            cart.updateCartList(lineItemsData);
          } catch (e) {}
        }
      },

      async moveToOrderNow(itemId: number, state): Promise<void> {
        if (state.app.user?.userId) {
          dispatch.app.showLoading();
          try {
            const lineItemsData = await cartService.moveToOrderNow(
              state.app.user?.userId,
              itemId
            );
            cart.updateCartList(lineItemsData);
          } catch (e) {}
          dispatch.app.hideLoading();
        }
      },

      async addQuantityToCart(
        { quoteId, serialNumber }: { quoteId: string; serialNumber: number },
        state
      ): Promise<void> {
        if (state.app.user?.userId) {
          dispatch.app.showLoading();
          try {
            await dispatch.jobConfig.addJobQuantityToCart({
              jobId: quoteId,
              serialNumber,
            });
            await cart.getList();
          } catch (e) {}
          dispatch.app.hideLoading();
        }
      },

      async deleteItem(itemId: number, state) {
        if (state.app.user?.userId) {
          dispatch.app.showLoading();
          try {
            const lineItemsData = await cartService.removeItem(
              state.app.user?.userId,
              itemId
            );
            cart.updateCartList(lineItemsData);
          } catch (e) {}
          dispatch.app.hideLoading();
        }
      },

      async changeQuantity(payload: Partial<CartLineItem>) {
        try {
          const res = await cartService.changeQuantity(payload);
          return res;
        } catch (e) {}
      },
    };
  },
});
